import * as React from 'react';
import styles from './checkout-error-message.module.scss';
import { sendProgressiveErrorUtag } from '~/utils/tealium';
import { useSelectedPaymentOption } from '~/store/wmap-store';
import { TYPES } from '~/modules/payment/constants';

export interface ICheckoutErrorData {
  errorHeading: string | undefined;
  errorMessage: string | undefined;
  invalidAttempts?: boolean;
  currentStep?: number;
  progressiveContactNum?: string | null;
  errorTestId?: string;
  errorCallCTATestId?: string;
  eventLabel?: string;
}

const CheckoutError: React.FC<ICheckoutErrorData> = ({
  errorHeading,
  errorMessage,
  invalidAttempts,
  progressiveContactNum,
  errorTestId,
  errorCallCTATestId,
  eventLabel,
}) => {
  const sentEventsRef = React.useRef<Set<string>>(new Set());
  const selectedPaymentMethod = useSelectedPaymentOption();
  const isProgressiveSelected = selectedPaymentMethod === TYPES.PROGRESIVE;

  React.useEffect(() => {
    if (
      eventLabel &&
      isProgressiveSelected &&
      !sentEventsRef.current.has(eventLabel)
    ) {
      sendProgressiveErrorUtag(eventLabel);
      sentEventsRef.current.add(eventLabel);
    }
  }, [eventLabel, isProgressiveSelected]);

  const phoneNum = `tel:+${progressiveContactNum?.replace(/[-()]/g, '')}`;
  return (
    <div data-testid={errorTestId} className={styles.section}>
      <p className={styles.title} tabIndex={0}>
        {errorHeading}
      </p>
      <p className={styles.message} tabIndex={0}>
        {errorMessage}
      </p>
      {invalidAttempts && (
        <a
          className={styles.button}
          role="button"
          tabIndex={0}
          href={phoneNum}
          data-testid={errorCallCTATestId}
        >
          Call Progressive Leasing
        </a>
      )}
    </div>
  );
};

export default CheckoutError;
